import React, { useMemo } from 'react'
import { CalendarClock } from 'lucide-react'
import { EmptyState } from '../../components/ui'
import { roundLabel } from '../tournamentStandings'
import { MatchScoreList } from './shared'

function MatchesTab({ tournament, canManage, saving, run, onReload }) {
  const matches = useMemo(() => tournament.matches || [], [tournament.matches])
  const rounds = useMemo(
    () => Array.from(new Set(matches.map((m) => m.roundNumber))).sort((a, b) => a - b),
    [matches]
  )

  if (matches.length === 0) {
    return (
      <EmptyState compact icon={CalendarClock} title="Ingen kamper ennå. Legg til lag og generer kampoppsett." />
    )
  }

  return (
    <div className="stack">
      {rounds.map((round) => {
        const inRound = matches.filter((m) => m.roundNumber === round)
        const played = inRound.filter((m) => m.status === 'COMPLETED').length
        return (
          <section key={round} className="card tn-card tn-round-card" aria-labelledby={`tn-round-${round}`}>
            <div className="tn-head-row center">
              <h2 id={`tn-round-${round}`} className="section-title tn-round-h">{roundLabel(tournament, round)}</h2>
              <span className="tn-footnote">{inRound.length} kamper · {played} spilt</span>
            </div>
            <MatchScoreList
              tournament={tournament}
              matches={inRound}
              canManage={canManage}
              saving={saving}
              run={run}
              onReload={onReload}
            />
          </section>
        )
      })}
    </div>
  )
}

export default MatchesTab
